var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarPassThanksLaptopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29.2031,
    height: 31.6367,
    rx: 7.38264,
    fill: "#1C1C1E",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.24609 22.6841C6.24609 22.3343 6.53243 22.0508 6.88563 22.0508H23.9399C24.2931 22.0508 24.5794 22.3343 24.5794 22.6841C24.5794 23.0339 24.2931 23.3174 23.9399 23.3174H6.88563C6.53243 23.3174 6.24609 23.0339 6.24609 22.6841Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.48754 9.05841C7.73828 9.8004 7.73828 10.9946 7.73828 13.3831V17.6053C7.73828 19.1976 7.73828 19.9937 8.23778 20.4884C8.73729 20.9831 9.54124 20.9831 11.1491 20.9831H19.6763C21.2842 20.9831 22.0881 20.9831 22.5876 20.4884C23.0871 19.9937 23.0871 19.1976 23.0871 17.6053V13.3831C23.0871 10.9946 23.0871 9.8004 22.3378 9.05841C21.5886 8.31641 20.3827 8.31641 17.9708 8.31641H12.8546C10.4427 8.31641 9.2368 8.31641 8.48754 9.05841Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8544 17.8164C12.5012 17.8164 12.2148 18.1 12.2148 18.4497C12.2148 18.7995 12.5012 19.0831 12.8544 19.0831H17.9707C18.3239 19.0831 18.6102 18.7995 18.6102 18.4497C18.6102 18.1 18.3239 17.8164 17.9707 17.8164H12.8544Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarPassThanksLaptopIcon);
export default __webpack_public_path__ + "static/media/calendar-pass-thanks-laptop-icon.1205e2d3b7416c2017cad0fafcd9e9a5.svg";
export { ForwardRef as ReactComponent };